import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

const { colors, spacing } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		color: titles,
		padding: spacing.lg,
		textAlign: 'center',
		minHeight: `100%`,
		width: `100%`,
		boxSizing: `border-box`,
		overflow: `auto`,
		display: `flex`,
		flexDirection: `column`,
		alignItems: `center`,
		background: colors.background.light,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		marginTop: 20,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	importOptions: {
		marginBottom: 45,
	},
	importOptionsRadio: {
		':not(:first-child)': {
			marginTop: 10,
		},
	},
	options: {
		display: 'inline-block',
		marginBottom: 40,
		marginLeft: 'auto',
		marginRight: 'auto',
		textAlign: 'left',
	},
	optionsSubtitle: {
		fontSize: 14,
		marginBottom: 4,
	},
	optionsTitle: {
		fontSize: 18,
		marginBottom: 20,
	},
	searchField: {
		marginBottom: 20,
		width: '100%',
	},
	tagOptions: {},
});
